<template>
  <div>
    <div class="plan-card-wrapper" :class="hasSubscription && !isSelected ? 'disabled' : ''">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ plan.name }}</h5>
          <p class="card-text mb-3">{{ plan.description }}</p>
          <ul class="list-group list-group-flush mb-2">
            <li class="list-group-item">
              <div class="row">
                <div class="col-6 text-uppercase font-weight-bold">
                  Price:
                </div>
                <div class="col-6 text-right">
                  ${{ plan.price }}
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-6 text-uppercase font-weight-bold">
                  Billing period:
                </div>
                <div class="col-6 text-right">
                  {{ plan.interval_length }} {{ plan.interval_unit }}
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-6 text-uppercase font-weight-bold">
                  Trial:
                </div>
                <div class="col-6 text-right">
                  <span v-if="plan.trial_length">{{ plan.trial_length }} {{ plan.trial_unit }}</span>
                  <span v-else>No</span>
                </div>
              </div>
            </li>
          </ul>
          <ul v-if="plan.addons.length" class="list-group list-group-flush mb-2">
            <li v-for="addon in plan.addons" :key="addon.code" class="list-group-item">
              <div class="row">
                <div class="col-6 text-uppercase font-weight-bold">
                  {{ addon.name }}
                </div>
                <div class="col-6 text-right">
                  ${{ addon.price }}
                </div>
              </div>
            </li>
          </ul>
          <p class="mb-2">{{ plan.auto_renewal ? 'Auto renew at the end of term' : 'Expire subscription at the end of term' }}</p>
          <button v-if="$_can('jobs.plans.send')" type="button" class="btn" :class="isSelected ? 'btn-completed mb-3' : 'btn-change'" :disabled="hasSubscription" @click="!hasSubscription && (showSendPlanModal = true)">{{ isSelected ? 'Plan selected by customer' : 'Send plan' }}</button>
          <div v-if="isSelected" class="subscription">
            <h5>Subscription</h5>
            <div class="row">
              <div class="col text-uppercase font-weight-bold">
                {{ job.recurly_subscription.state }} <i class="fa fa-circle pl-3"
                                                        :class="job.recurly_subscription.state"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6 text-uppercase font-weight-bold">
                Started on:
              </div>
              <div class="col-6 text-right">
                {{ job.recurly_subscription.activated_at }}
              </div>
            </div>
            <div class="row">
              <div class="col-6 text-uppercase font-weight-bold">
                ID:
              </div>
              <div class="col-6 text-right">
                <div class="d-flex pointer position-relative">
                  <span class="uuid pointer">
                    {{ job.recurly_subscription.uuid }}
                  </span>
                  <i
                    class="fa fa-copy list-box-icon copy-icon pointer"
                    @click.prevent.stop="copyToClipboard(job.recurly_subscription.uuid, 'Successfully copied to clipboard')"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="isSent">
            <p class="text-success">
              <i class="fa fa-check-circle-o pr-2" />
              Plan was sent to the customer
            </p>
          </div>
        </div>
      </div>
    </div>
    <SendPlan v-if="showSendPlanModal" :job="job" :plan="plan" @close="showSendPlanModal = false" @planSent="$emit('planSent')" />
  </div>
</template>

<script>
import toastr from 'toastr';
import SendPlan from '../modals/SendPlan.vue';

export default {
  name: 'Plan',
  components: { SendPlan },
  props: {
    job: { type: Object, default: null },
    plan: { type: Object, default: null },
  },
  data() {
    return {
      showSendPlanModal: false,
    };
  },
  computed: {
    hasSubscription() {
      return !!this.job.recurly_subscription;
    },
    isSelected() {
      return (
        this.job.recurly_subscription &&
        this.job.recurly_subscription.plan.recurly_id === this.plan.recurly_id
      );
    },
    isSent() {
      return (
        this.job.recurly_sent_plan_id && this.job.recurly_sent_plan_id === this.plan.recurly_id
      );
    },
  },
  methods: {
    copyToClipboard(uuid, message) {
      this.$copyText(uuid).then(() => toastr.success(message, '', { timeOut: 1000 }));
    },
  },
};
</script>

<style scoped lang="scss">
.plan-card-wrapper {
  .card {
    border: 1px solid rgba(0, 0, 0, 0.125) !important;
    .subscription {
      i.fa-circle {
        &.active {
          color: #00bfa5;
        }
        &.canceled {
          color: #f44336;
        }
        &.expired {
          color: #ffab00;
        }
      }
      .uuid {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
      }
      .copy-icon {
        left: unset;
        right: 0;
        padding-right: 0;
      }
    }
  }
  .card-body {
    p {
      text-align: left;
    }
    .card-text {
      min-height: 50px;
    }

    .list-group {
      .list-group-item {
        padding: 0.25rem 0;
        border: 0;
      }
      .list-group-item:last-child {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
      }
    }
    .btn:disabled {
      pointer-events: none;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/subcomponents/Plan.vue